import { configureStore } from '@reduxjs/toolkit';
/* import { conversion } from '../app/MacRO1/middleware/conversion'; */
import store from '../app/store';
/* import { conversionMacro2 } from '../app/Macro2/middleware/conversion'; */

export const redux = configureStore({
    /*     middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false }).concat(conversionMacro2), */
    reducer: store,
});

export const getState = () => redux.getState();

export type RootState = ReturnType<typeof redux.getState>;

export type AppDispatch = typeof redux.dispatch;

export interface IInitialState<T> {
    data?: T;
    error?: IError;
    pending?: boolean;
    showDischargeAlert?: boolean;
    initialState: boolean;
}

export interface IError {
    status: number;
    data: string;
}
